"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSViewModeAPISymbol = void 0;
exports.DSViewModeAPISymbol = Symbol('DSViewModeAPISymbol');
//# sourceMappingURL=viewMode.js.map